import React from 'react'

import HowToDialog from 'components/HowToDialog'
import T from 'components/FormattedMessage'

import { withStyles, createStyles, WithStyles, Theme } from '@material-ui/core'
import { Typography, Grid } from '@material-ui/core'

import TutorialProgress from './components/TutorialProgress'

interface Props {
  open: boolean
  onClose?: () => void
}

const styles = (theme: Theme) => createStyles({
  iconContainer: {
    height: 180,
    width: 180,
    marginBottom: theme.spacing() * 2,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  progressContainer: {
    marginBottom: theme.spacing(),
  },
  secondaryActionLabel: {
    marginRight: theme.spacing() * 2,
    cursor: 'pointer',
  },
})

type InjectedProps = Props & WithStyles<typeof styles>

const WelcomeTutorial: React.SFC<InjectedProps> = ({ classes, open, onClose }) => {
  const [slide, setSlide] = React.useState(1)
  const [slideIconUrl, setSlideIconUrl] = React.useState('')
  const isLastSlide = slide === 4

  React.useEffect(() => {
    import(`./assets/slide${slide}.svg`)
      .then(mod => setSlideIconUrl(mod.default || mod))
  }, [slide])

  const primaryActionLabel = isLastSlide
    ? <T id="onboarding_tutorial_play" />
    : <T id="onboarding_tutorial_next" />

  const secondaryActionLabel = isLastSlide
    ? <T id="onboarding_tutorial_restart" />
    : <T id="onboarding_tutorial_skip" />

  const onPrimaryActionClick = isLastSlide
    ? onClose
    : () => setSlide(slide + 1)

  const onSecondaryActionClick = isLastSlide
    ? () => setSlide(1)
    : onClose

  return (
    <HowToDialog
      open={open}
      onClose={onClose}
      variant="dark"
      icon={(
        <div className={classes.iconContainer}>
          <img alt="" src={slideIconUrl} />
        </div>
      )}
      headline={<T id={`onboarding_tutorial_title${slide}`} />}
      message={<T id={`onboarding_tutorial_info${slide}`} />}
      actionLabel={primaryActionLabel}
      onActionClick={onPrimaryActionClick}
      bottomChild={(
        <Grid container alignItems="center" className={classes.progressContainer}>
          <Grid item xs={4} />
          <Grid item xs={4}>
            <TutorialProgress count={4} currentIndex={slide - 1} />
          </Grid>
          <Grid item xs={4}>
            <Typography
              color="primary"
              variant="body1"
              align="right"
              className={classes.secondaryActionLabel}
              onClick={onSecondaryActionClick}
            >
              {secondaryActionLabel}
            </Typography>
          </Grid>
        </Grid>
      )}
    />
  )
}

export default withStyles(styles)(WelcomeTutorial)
